import {
  DISPLAY_CURRENCIES,
  DOLLAR_COINS,
  ICON_TYPES,
} from "@shared/common/constants";
import { DisplayCurrency } from "@shared/types";
import { Market } from "types";
import React, { CSSProperties, useMemo } from "react";
import LiveSymbolPrice from "common/LiveComponents/LiveSymbolPrice";
import { TextWithPrecisionAndIconProps } from "common/Text/TextWithPrecisionAndIcon";

interface WatchlistPriceProps {
  market: Market;
  fontSize: number | string;
  textColor: string;
  style?: CSSProperties;
  showNoneDisplayCurrencyIcons?: boolean;
}

const WatchlistPrice = ({
  market,
  style,
  fontSize,
  textColor,
  showNoneDisplayCurrencyIcons,
}: WatchlistPriceProps) => {
  const { price, symbol, exchange } = market;
  let pair = symbol.split("/")[1];

  let displayCurrency: DisplayCurrency | undefined;
  if (DOLLAR_COINS.includes(pair)) displayCurrency = DISPLAY_CURRENCIES.USD;
  else if (pair === DISPLAY_CURRENCIES.BTC)
    displayCurrency = DISPLAY_CURRENCIES.BTC;

  const textProps = useMemo(() => {
    let textProps: TextWithPrecisionAndIconProps | undefined;
    if (displayCurrency || showNoneDisplayCurrencyIcons) {
      textProps = {
        iconType: displayCurrency
          ? ICON_TYPES.DISPLAY_CURRENCY
          : ICON_TYPES.COIN,
        coinOrExchangeName: displayCurrency ? undefined : pair,
        currency: displayCurrency,
      };
    }
    return textProps;
  }, [displayCurrency, showNoneDisplayCurrencyIcons, pair]);

  return (
    <LiveSymbolPrice
      symbol={symbol}
      exchange={exchange}
      initialPrice={Number(price)}
      fontSize={fontSize}
      textColor={textColor}
      hideIcon={!showNoneDisplayCurrencyIcons && !displayCurrency}
      textProps={textProps}
      style={style}
    />
  );
};

export default WatchlistPrice;
